import { FC } from "react";
import CategoryStatusTable from "../CategoryStatusTable";
import useBizSheetCategoryStatus, { Props, ReceivedProps } from "./hook";
import { Styles } from "./styled";

const BizSheetCategoryStatusLayout: FC<Props> = () => {
  return (
    <Styles>
      <CategoryStatusTable screen="app" recordType="status" />
      <CategoryStatusTable screen="app" recordType="category" />
    </Styles>
  );
};

const BizSheetCategoryStatus: FC<ReceivedProps> = (props) => (
  <BizSheetCategoryStatusLayout {...useBizSheetCategoryStatus(props)} />
);

export default BizSheetCategoryStatus;
